import { UAParser } from 'ua-parser-js';

export default ({ app, store }) => {
  const paramKey = 'vid';
  const paramValue = store.state.tracking.visitorFingerprint;

  const updateLinks = () => {
    const { origin } = window.location;

    document.querySelectorAll('a[href]').forEach((link) => {
      try {
        const url = new URL(link.href, origin);

        // Skip if:
        if (
          !url.href.startsWith(origin) // external link
          || url.searchParams.has(paramKey) // already has param
          || link.href.startsWith('#') // anchor link
          // eslint-disable-next-line no-script-url
          || link.href.startsWith('javascript:') // javascript link
          || link.target === '_blank' // opens in new tab (optional)
        ) {
          return;
        }

        url.searchParams.set(paramKey, paramValue);
        // eslint-disable-next-line no-param-reassign
        link.href = url.toString();
      } catch (e) {
        // ignore bad URLs
      }
    });
  };

  const { browser } = UAParser(navigator.userAgent);

  // Run once on load
  if (browser.type === 'inapp' && process.client) {
    window.addEventListener('DOMContentLoaded', updateLinks);

    // Run after every route change
    app.router.afterEach(() => {
      setTimeout(updateLinks, 100); // delay to ensure DOM is updated
    });
  }
};
